import { comics } from '@/mocks/comics';
import ComicCard from './ComicCard';
import { Link } from 'react-router-dom';

export default function FeaturedComics() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-50" aria-labelledby="featured-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 id="featured-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选优质韩国漫画，本本都是口碑佳作</p>
          </div>
          <Link
            to="/category?sort=rating"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="medium" />
          ))}
        </div>
        <div className="sm:hidden mt-4 text-center">
          <Link
            to="/category?sort=rating"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}